class MediaGallery extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      liveRegion: this.querySelector('[id^="GalleryStatus"]'),
      viewer: this.querySelector('[id^="GalleryViewer"]'),
      media: this.querySelectorAll('[data-media-id]'),
    };
    this.desktopStacked = this.dataset.desktopLayout === 'stacked';

    document.body.addEventListener(
      'setActiveMediaTrigger',
      this.setActiveMedia.bind(this),
    );
  }

  setActiveMedia(event) {
    const isStickyForm = event.detail.isStickyForm;
    if (isStickyForm) { return }

    const mediaId = event.detail.mediaId;
    const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
    this.updateGalleryThumbs(activeMedia);
  }

  thumbClickHandler(index) {
    const activeMedia = this.querySelector(`[data-slide-index="${index}"]`);
    this.updateGalleryThumbs(activeMedia);
  }

  updateGalleryThumbs(activeMedia) {
    const mql = window.matchMedia('(min-width: 990px)');

    this.elements.media.forEach((element) => {
      element.classList.remove('is-active');
    });

    activeMedia?.classList.add('is-active');

    if (mql.matches && this.desktopStacked) {
      // Desktop stacked layout
      activeMedia.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } else {
      // Mobile view and desktop slider layout
      const carousel = this.querySelector('embla-component');
      const activeMediaSlide = activeMedia.closest('.embla__slide');
      const activeMediaIndex = Number(
        activeMediaSlide?.getAttribute('data-slide-index'),
      );

      if (carousel && activeMediaSlide) {
        carousel.slideToIndex(activeMediaIndex);
      }
    }
  }

  announceLiveRegion(activeItem, position) {
    const image = activeItem.querySelector('.product__modal-opener--image img');
    if (!image) return;
    image.onload = () => {
      this.elements.liveRegion.setAttribute('aria-hidden', false);
      this.elements.liveRegion.innerHTML =
        window.accessibilityStrings.imageAvailable.replace('[index]', position);
      setTimeout(() => {
        this.elements.liveRegion.setAttribute('aria-hidden', true);
      }, 2000);
    };
    image.src = image.src; // Trigger reload
  }

  preventStickyHeader() {
    this.stickyHeader =
      this.stickyHeader || document.querySelector('sticky-header');
    if (!this.stickyHeader) return;
    this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
  }
}

customElements.define('media-gallery', MediaGallery);
